import { Node_Type } from "./../ricos-types";
const DEFAULT_PALETTE_BG = [
  "#FF0000",
  "#FFFFFF",
  "#303030",
  "#3A54B4",
  "#BFAD80",
  "#DDDDDD"
];
const SOURCE = {
  KEYBOARD_SHORTCUT: "keyboard shortcut",
  PLUS_BUTTON: "plus button",
  CONTEXT_MENU: "context menu"
};
const LOCATION = {
  RIGHT: "right",
  LEFT: "left",
  ABOVE: "above",
  BELOW: "below"
};
const CATEGORY = {
  COLUMN: "column",
  ROW: "row",
  ENTIRE_TABLE: "entire table",
  CELL_BORDER: "cell border",
  ROW_HEADER: "row header",
  COLUMN_HEADER: "column header",
  CELL_FORMATTING: "cell formatting",
  RANGE: "range",
  ROW_RANGE: "row range",
  COLUMN_RANGE: "column range"
};
const CELL_MANUAL_MIN_WIDTH = 65;
const CELL_AUTO_MIN_WIDTH = 120;
const ROW_DEFAULT_HEIGHT = 47;
const TABLE_BUTTONS = {
  FORMATTING: `${Node_Type.TABLE}.formatting`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  BACKGROUND_COLOR: `${Node_Type.TABLE}.backgroundColor`,
  ROW_HEADER: `${Node_Type.TABLE}.rowHeader`,
  COLUMN_HEADER: `${Node_Type.TABLE}.columnHeader`,
  BORDER: `${Node_Type.TABLE}.border`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`
};
const TABLE_BUTTONS_MODALS_ID = {
  BORDER: `${Node_Type.TABLE}.border`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`
};
const TABLE_COMMANDS_KEYS = {
  CLEAR: "clearCell",
  DELETE_TABLE: "deleteTable",
  DELETE_ROW: "deleteRow",
  DELETE_COLUMN: "deleteColumn",
  INSERT_ABOVE: "addRowBefore",
  INSERT_BELOW: "addRowAfter",
  INSERT_LEFT: "addColumnBefore",
  INSERT_RIGHT: "addColumnAfter",
  MERGE_CELLS: "mergeCells",
  SPLIT_CELL: "splitCell",
  DISTRIBUTE_ROWS: "distributeRows",
  DISTRIBUTE_COLUMNS: "distributeColumns",
  SELECT_ROWS: "selectRow",
  SELECT_COLUMNS: "selectColumn"
};
const TABLE_COLOR_PICKER = "table-colorPicker";
const BORDER_TYPES = { borders: "borders", outsideBorders: "outsideBorders" };
export {
  BORDER_TYPES,
  CATEGORY,
  CELL_AUTO_MIN_WIDTH,
  CELL_MANUAL_MIN_WIDTH,
  DEFAULT_PALETTE_BG,
  LOCATION,
  ROW_DEFAULT_HEIGHT,
  SOURCE,
  TABLE_BUTTONS,
  TABLE_BUTTONS_MODALS_ID,
  TABLE_COLOR_PICKER,
  TABLE_COMMANDS_KEYS
};
//# sourceMappingURL=consts.js.map
